import { jsxs as h, jsx as d } from "react/jsx-runtime";
import { c as n } from "./index-65016bfa.mjs";
import { useRef as $ } from "react";
import p, { css as m } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as b } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as k } from "./icon.js";
import { H as N } from "./helperText-d9646f54.mjs";
import { u as P } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as W } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
const j = "Switch", q = p.div`
  &.Switch__Wrapper {
    ${({
  theme: {
    components: { switch: t }
  }
}) => m(t.Wrapper)};
  }
`, E = p.label`
  &.Switch__input-wrapper {
    ${({
  theme: {
    components: { switch: t }
  }
}) => m(t.SwitchInputWrapper)};
  }
`, H = p.span`
  &.Switch__slider {
    ${({
  theme: {
    components: { switch: t }
  }
}) => m(t.SwitchSlider)};
  }
`, K = p(k)`
  &.Switch__slider-icon {
    ${({
  theme: {
    components: { switch: t }
  }
}) => m(t.SwitchSliderIcon)};
  }
`;
function Y({
  size: t = "medium",
  isDisabled: s,
  isChecked: a,
  onChange: o,
  accessibilityOptions: f = { ariaLabel: "toggle switch" },
  inputState: _,
  helperTextProp: i = {
    secondaryProp: {
      state: _
    }
  }
}) {
  var l, S;
  const y = b({ label: "Switch" }), w = $(W(j)), c = {
    defaultId: ((l = i == null ? void 0 : i.defaultProp) == null ? void 0 : l.id) || `default_${w.current}_message_id`,
    secondaryId: ((S = i == null ? void 0 : i.secondaryProp) == null ? void 0 : S.id) || `secondary_${w.current}_message_id`
  }, r = i;
  r && (r.defaultProp && (r.defaultProp.id = c.defaultId), r.secondaryProp && (r.secondaryProp.id = c.secondaryId));
  const u = P("switch", {
    ariaChecked: a,
    ariaDisabled: s,
    ariaLabelledBy: `${c == null ? void 0 : c.defaultId} ${c == null ? void 0 : c.secondaryId}`,
    ...f
  }), I = (e) => {
    if (e.key === " " || e.key === "Enter") {
      if (e.preventDefault(), s)
        return;
      o == null || o(e);
    }
  };
  return /* @__PURE__ */ h(
    q,
    {
      className: n(["Switch", "Switch__Wrapper"]),
      "data-testid": "switch",
      ...y,
      children: [
        /* @__PURE__ */ h(
          E,
          {
            onKeyDown: I,
            ...u,
            tabIndex: s ? -1 : 0,
            className: n([
              "Switch__input-wrapper",
              {
                [`Switch__input-wrapper--${t}`]: t,
                "Switch__input-wrapper--disabled": s,
                "Switch__input-wrapper--checked": a
              }
            ]),
            children: [
              /* @__PURE__ */ d(
                "input",
                {
                  type: "checkbox",
                  disabled: s,
                  checked: a,
                  onChange: o,
                  className: "Switch__input",
                  ...u,
                  "data-testid": "checkbox",
                  hidden: !0
                }
              ),
              /* @__PURE__ */ d(
                H,
                {
                  className: n([
                    "Switch__slider",
                    {
                      [`Switch__slider--${t}`]: t,
                      "Switch__slider--disabled": s,
                      "Switch__slider--checked": a
                    }
                  ]),
                  children: /* @__PURE__ */ d(
                    K,
                    {
                      name: a ? "checkmark" : "cancelClose",
                      className: n(["Switch__slider-icon", { "Switch__slider-icon--checked": a }])
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ d(
          N,
          {
            defaultProp: r.defaultProp,
            secondaryProp: { state: _, ...r.secondaryProp }
          }
        )
      ]
    }
  );
}
export {
  Y as Switch
};
